module.exports = __webpack_public_path__ + "img/news15-0.c9503c11.png";